import React from "react";

function LoginSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect width="20" height="20" fill={props.bg_color} rx="10"></rect>
      <path
        fill="#262626"
        d="M10.491 14.165v-.458h3.218V7.29H10.49v-.458h3.676v7.333H10.49zm-.325-2.044l-.323-.33 1.064-1.063H6.842v-.458h4.065L9.843 9.206l.322-.329 1.622 1.622-1.621 1.622z"
      ></path>
    </svg>
  );
}

export default LoginSvg;
